import React, {Component} from 'react'
import PropTypes from 'prop-types'

class ProductType extends Component {
    _onClickType = (value) => {
        const {onChangeProductType} = this.props

        if (typeof onChangeProductType === 'function') {
            onChangeProductType(value)
        }
    }

    render() {
        const {types} = this.props

        return (
            <td className="ProductType">
                {
                    !!types && types.length > 0 && <span onClick={() => this._onClickType([types])}>{types}</span>
                }
            </td>
        )
    }
}

ProductType.propTypes = {
    types: PropTypes.string,
    onChangeProductType: PropTypes.func
}

export default ProductType